export default __webpack_public_path__ + "static/media/mariadb.77cee16a.svg";